// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__i6pXN","errors":"Errors_errors___yiwI"};